import { User } from "@shared-database/models/user";
import { sharedSchema } from "@shared-database/pgSchema";
import {
  leoID,
  leoNotNullForeignID,
  timestampColumns,
} from "@shared-database/utils";
import { type InferInsertModel, type InferSelectModel } from "drizzle-orm";
import { text, unique, index } from "drizzle-orm/pg-core";

export const FeatureFlagUser = sharedSchema.table(
  "FeatureFlagUser",
  {
    // Mixins
    ...timestampColumns,

    userId: leoNotNullForeignID("userId").references(() => User.id, {
      onDelete: "cascade",
    }),
    feature: text("feature").notNull(),

    // Properties
    id: leoID("id"),
  },
  (table) => [
    index("FeatureFlagUser_idIdx").on(table.id),
    index("FeatureFlagUser_userIdIdx").on(table.userId),
    index("FeatureFlagUser_featureIdx").on(table.feature),
    unique().on(table.userId, table.feature),
  ],
);

// Types
export type FeatureFlagUserType = InferSelectModel<typeof FeatureFlagUser>;
export type FeatureFlagUserInsertType = InferInsertModel<
  typeof FeatureFlagUser
>;
